import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Icon, Table, TableColumnOpcoes, View, TableSearch } from '@components';
import { getConfiguracoes, deleteConfiguracao } from '@ducks/conectoresConfiguracoes';
import styled from 'styled-components';

const ColumnConectorIdentify = styled(View)`
  font-size: 16px;
  font-weight: bold;
  width: 40%;
`;

const IconInativo = styled(View)`
  color: #dc3545;
`;

const IconAtivo = styled(View)`
  color: #28a745;
`;

const SubColumnVersao = styled(View)`
  font-size: 12px;
  font-weight: normal;
`;

export default function TableConfiguracoes() {
  const dispatch = useDispatch();
  const history = useHistory();
  const { idCliente } = useParams();
  const [st1, setSt1] = useState('');
  const [st2, setSt2] = useState('');

  const configuracoes = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('configuracoes').toArray());
  const loadingConfiguracoes = useSelector(({ conectoresConfiguracoes }) => conectoresConfiguracoes.get('loadingConfiguracoes'));

  const handleSearch = () => {
    dispatch(getConfiguracoes(idCliente));
  };

  const excluirConector = (id) => {
    dispatch(deleteConfiguracao(id));
  };

  useEffect(() => {
    handleSearch();
  }, []);

  const columns = [
    {
      title: 'Conector Identify',
      dataIndex: 'conectorIdentify',
      key: 'conectorIdentify',
      width: '60%',
      ...TableSearch('conectorIdentify', 'conector', { st1, setSt1, st2, setSt2 }),
      render: (text, configuracao) => (
        <View>
          <ColumnConectorIdentify>
            {text}
            <SubColumnVersao>v{configuracao.versao}</SubColumnVersao>
          </ColumnConectorIdentify>
        </View>
      ),
    },
    {
      title: 'Ativo',
      dataIndex: 'ativo',
      key: 'ativo',
      align: 'center',
      width: '20%',
      render: (text, configuracao) => (
        <View>
          {configuracao.ativo ? (
            <IconAtivo>
              <Icon.CheckCircleFilled />
            </IconAtivo>
          ) : (
            <IconInativo>
              <Icon.CloseCircleFilled />
            </IconInativo>
          )}
        </View>
      ),
    },
    {
      title: 'Opções',
      dataIndex: 'id',
      key: 'id',
      align: 'right',
      width: '20%',
      render: (text, configuracao) => (
        <TableColumnOpcoes>
          <Icon.Edit action={() => history.push(`/conectores/configuracao/${configuracao.id}`)} />
          <Icon.Delete
            popConfirmTitle={`Deseja excluir o conector ${configuracao.conectorIdentify}?`}
            action={() => excluirConector(configuracao.id)}
          />
          <Icon.Detail action={() => history.push(`/conectores/configuracao/${idCliente}/${configuracao.id}/informacoes`)} />
        </TableColumnOpcoes>
      ),
    },
  ];

  return <Table rowKey="id" columns={columns} dataSource={configuracoes} loading={loadingConfiguracoes} hidePagination />;
}
